"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CurrencyFieldValueGetter = void 0;
const safe_field_value_1 = require("../../safe-field-value");
const number_1 = require("../../type-checking/number");
class CurrencyFieldValueGetter extends safe_field_value_1.BaseFieldValueGetter {
    constructor() {
        super(...arguments);
        this.isValidFieldValue = (fieldValue) => {
            return (0, number_1.isDecimal128Value)(fieldValue) || (0, number_1.isNullableNumberValue)(fieldValue);
        };
        this.getEmptyValue = () => null;
    }
}
exports.CurrencyFieldValueGetter = CurrencyFieldValueGetter;
